<template>
  <div id="dc-user-manager">
    <dd-header
      ref="menuRef"
      :headerType=2
    />
    <div class="container">
      <div class="content">
        <div class="title">
          <h2>ユーザー管理</h2>
        </div>
        <div class="data-area">
          <div class="upper">
            <button class="main_btn" @click="onClickUserInvitation">新規ユーザーの招待</button>
          </div>
          <table>
            <tbody>
              <tr>
                <th>管理番号</th>
                <th>タイプ</th>
                <th>氏名</th>
                <th>ID/メールアドレス</th>
                <th>最終ログイン日</th>
                <th class="hid_th md"></th>
                <th class="hid_th sm" ></th>
                <th class="hid_th sm"></th>
              </tr>
              <template v-if="userList && userList.length > 0">
                <tr v-for="(user, index) in userList" :key="index">
                  <td>{{ user.userId }}</td>
                  <td>{{ userType(user.userType) }}</td>
                  <td>{{ user.userLastName }} {{user.userFirstName}}</td>
                  <td>{{ user.email }}</td>
                  <td>{{ lastLogin(user.userId) }}</td>
                  <td class="hid_td"><button :class="{main_btn: true, disabled: isLoginUser(user.userId)}" @click="onEdit(user)">編集</button></td>
                  <td class="hid_td"><button :class="{main_btn: true, disabled: isLoginUser(user.userId)}" @click="onDel(user)">削除</button></td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import {mapActions, mapState} from 'vuex'
import store from '../../store/index'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
import * as AppEc from '../utils/AppEc'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
import Header from '../components/common/DcHeader'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  name: 'UserManageModal',
  store: store,
  components: {
    'dd-header': Header,
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      /** モーダル判定 */
      modalShown: false
    }
  },
  watch: {
    modalShown: function () {
      /** キャンバス内キーボード制御 */
      if (this.modalShown) {
        document.addEventListener('keydown', this.onKeydown)
      } else {
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  computed: {
    // ユーザー一覧
    ...mapState({
      userList: state => state.userList
    })
  },
  methods: {
    ...mapActions({ getUserList: 'loadUserListDc' }),
    /** モーダル表示 */
    showModal: function () {
      this.modalShown = true
    },
    onEdit: function (userObj) {
      let modalData = {
        userObj: userObj
      }
      AppEc.showUserModal(modalData)
    },
    onDel: function (userObj) {
      let modalData = {
        messages: ['本当に削除しますか？'],
        modalType: 'confirm',
        textAlign: 'center',
        onOk: () => {
          let payload = {
            userId: userObj.userId,
            userType: userObj.userType
          }
          axios.post(DC_URL.USER + '/delete-user', payload
          ).then(response => {
            this.$store.dispatch('loadUserListDc')
            let modalData = {
              messages: ['削除しました。'],
              textAlign: 'center'
            }
            App.showModal(modalData)
          }).catch(error => {
            Api.handleError(error, this.errorMessage, this.validateErrorMessages)
            this.$router.push('/mmstyle/error')
          })
        }
      }
      App.showModal(modalData)
    },
    /** 最終ログイン日時 */
    lastLogin: function (id) {
      if (this.userList && this.userList.length > 0) {
        // idで該当するユーザーを検索
        let userObj = this.userList.find(obj => { if (obj.userId === id) return obj })
        if (userObj.userLastlogindt === null) {
          return ''
        } else {
          return moment(userObj.userLastlogindt).format('YYYY/MM/DD HH:mm:ss')
        }
      }
    },
    onClickUserInvitation: function () {
      AppEc.showInviteUserModal()
    },
    isLoginUser: function (userId) {
      console.log('userId:' + userId + ' login:' + this.loginUserId)
      if (userId === this.loginUserId) {
        return true
      }
      return false
    },
    userType: function (val) {
      if (val === 'DC_ADMIN') {
        return '管理者'
      } else if (val === 'DC_USER') {
        return '使用者'
      }
      return ''
    }
  },
  mounted: function () {
    this.$store.dispatch('loadUserListDc', {reload: true})
  },
  created: function () {
    let userInfo = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
    this.loginUserId = userInfo.userId
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
#dc-user-manager {
  .title {
    font-size: 2em;
  }
  .content {
    margin: 110px auto 0 auto;
    max-width: 80%;
    height: calc(100vh - 110px);
  }
}
.upper{
  margin-bottom: 30px;
  text-align: left;
}
.data-area {
  margin: 40px auto;
}
.title-area {
  display:flex;
}
.um-modal {
  max-height: 100%;
  max-width: 1500px;
  padding-left: 40px;
  padding-right: 40px;
}
table{
  text-align: center;
}
h2{
  margin: auto;
  padding-right: 29px;
}
.hid_th{
  background:none;
  border: none;
}
.sm {
  width: 35px;
}
.md{
  width: 127px
}
.hid_td{
  border:none;
}
</style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcUserManager.vue